import { render } from "./CartSavedAddressPicker.vue?vue&type=template&id=6d60c0c8"
import script from "./CartSavedAddressPicker.vue?vue&type=script&lang=js"
export * from "./CartSavedAddressPicker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__